import { Link } from "react-router-dom";

export default function Impressum() {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 md:py-20" data-testid="impressum-page">
      <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">
        <span className="divider-thin" />Rechtliches
      </div>
      <h1 className="font-heading font-bold text-3xl md:text-5xl tracking-tight text-slate-900 mb-3 leading-[1.05]">
        <span className="font-serif italic font-medium">Impressum</span> &amp; Offenlegung
      </h1>
      <p className="text-sm text-slate-500 mb-12">
        gemäß § 5 ECG, § 14 UGB, § 25 MedienG und § 63 GewO
      </p>

      <div className="bg-emerald-50 border-l-4 border-emerald-500 p-5 mb-10 text-xs text-emerald-900">
        <strong>Verifizierte Unternehmensdaten:</strong> UID-Nummer und GISA-Zahl sind eingetragen. Vor finaler Veröffentlichung empfehlen wir dennoch eine Kontrolle durch die WKO Oberösterreich oder einen Rechtsanwalt.
      </div>

      <div className="space-y-10 text-sm text-slate-700 leading-relaxed">
        <Section title="Diensteanbieter / Medieninhaber">
          <p>
            <strong className="text-slate-900">D.R Automobile</strong><br />
            Inhaber: D. R.<br />
            Ringgasse 6<br />
            4840 Vöcklabruck<br />
            Österreich
          </p>
        </Section>

        <Section title="Kontakt">
          <p>
            Telefon: <a href="tel:+436677608726" className="text-slate-900 underline">+43 667 760 8726</a><br />
            E-Mail: <a href="mailto:kontakt@dr-automobile.at" className="text-slate-900 underline">kontakt@dr-automobile.at</a><br />
            Web: <a href="https://dr-automobile.at" className="text-slate-900 underline">dr-automobile.at</a>
          </p>
        </Section>

        <Section title="Unternehmensgegenstand">
          <p>Handel mit Kraftfahrzeugen, insbesondere mit gebrauchten Personenkraftwagen.</p>
        </Section>

        <Section title="Rechtsform & Registereintrag">
          <p>
            Rechtsform: Einzelunternehmen<br />
            UID-Nummer: <strong>ATU81677507</strong>
          </p>
        </Section>

        <Section title="Gewerbe & Aufsichtsbehörde">
          <p>
            Gewerbe: <strong>Handelsgewerbe gemäß § 124 Z 11 GewO 1994</strong> (Kraftfahrzeughandel, freies Gewerbe)<br />
            GISA-Zahl: <strong>39730541</strong><br />
            Gewerbebehörde: Bezirkshauptmannschaft Vöcklabruck<br />
            Mitgliedschaft: Wirtschaftskammer Oberösterreich (WKO), Fachgruppe Fahrzeughandel
          </p>
        </Section>

        <Section title="Anwendbare Rechtsvorschriften">
          <p>
            Gewerbeordnung 1994 (GewO), Konsumentenschutzgesetz (KSchG), Fern- und Auswärtsgeschäfte-Gesetz (FAGG), Allgemeines Bürgerliches Gesetzbuch (ABGB), Unternehmensgesetzbuch (UGB).
          </p>
          <p className="mt-2">
            Einsehbar im Rechtsinformationssystem des Bundes:{" "}
            <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer" className="text-slate-900 underline">ris.bka.gv.at</a>
          </p>
        </Section>

        <Section title="Online-Streitbeilegung (OS-Plattform)">
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung bereit:{" "}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-slate-900 underline">ec.europa.eu/consumers/odr</a>.
            Wir sind nicht verpflichtet und nicht bereit, an einem Schlichtungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </Section>

        <Section title="Haftungsausschluss (Disclaimer)">
          <p>
            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
            externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
            verantwortlich. Die Angaben auf dieser Website wurden mit größter Sorgfalt erstellt — Irrtümer,
            Tippfehler und zwischenzeitliche Änderungen bleiben dennoch vorbehalten.
          </p>
        </Section>

        <Section title="Urheberrecht">
          <p>
            Alle Inhalte (Texte, Bilder, Grafiken) auf dieser Website sind — soweit nicht anders gekennzeichnet —
            urheberrechtlich geschützt. Eine Vervielfältigung oder Weiterverwendung außerhalb der gesetzlichen
            Schranken bedarf der vorherigen schriftlichen Zustimmung des Verfassers.
          </p>
        </Section>

        <Section title="Bildnachweis">
          <p>Fotografien: Eigene Aufnahmen sowie lizenzfreie Stockfotos (Unsplash, Pexels) und KI-generierte Visualisierungen.</p>
        </Section>

        <div className="pt-6 border-t border-slate-200 text-xs text-slate-500">
          Lesen Sie auch unsere <Link to="/agb" className="underline text-slate-900">AGB</Link> und <Link to="/datenschutz" className="underline text-slate-900">Datenschutzerklärung</Link>.
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading font-semibold text-lg text-slate-900 mb-3">{title}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}
